import { useMemo, useState } from "react";
import { DICT, flattenDict } from "@/lib/i18n";

const GROUPS = { nav: "Menu", hero: "Opening", marquee: "Scrolling banner", courses: "CQB Courses", gear: "Merch", ws: "Workshop", kh: "Killhouse", ethos: "Ethos", gallery: "Gallery", pt: "Partners", contact: "Contact", inq: "Inquiry form", f: "Form labels", footer: "Footer" };
const groupOf = (path) => path.split(/[.|]/)[0];

export const TextsPanel = ({ texts, onChange }) => {
  const [q, setQ] = useState("");
  const rows = useMemo(() => {
    const pt = Object.fromEntries(flattenDict(DICT.pt));
    return flattenDict(DICT.en).map(([path, en]) => ({ path, en, pt: pt[path] ?? "" }));
  }, []);
  const shown = rows.filter((r) => !q || `${r.en} ${r.pt}`.toLowerCase().includes(q.toLowerCase()));
  const set = (lang, path, val) => onChange({ ...texts, [lang]: { ...(texts[lang] || {}), [path]: val } });
  let last = null;

  return (
    <div>
      <p className="text-sm text-[var(--muted)] mb-4">Type new wording in the boxes. Leave a box empty to keep the original text (shown in grey).</p>
      <input data-testid="texts-search" className="field mb-6 max-w-md" placeholder="Search text…" value={q} onChange={(e) => setQ(e.target.value)} />
      <div className="space-y-1">
        {shown.map((r) => {
          const g = groupOf(r.path);
          const header = g !== last ? (last = g) : null;
          return (
            <div key={r.path}>
              {header && <p className="font-display text-2xl font-black uppercase mt-8 mb-2">{GROUPS[g] || g}</p>}
              <div data-testid={`text-row-${r.path}`} className="grid md:grid-cols-2 gap-x-6 gap-y-1 border-b border-[var(--line)] py-3">
                {["en", "pt"].map((lang) => {
                  const long = r[lang].length > 70;
                  const props = {
                    className: "field text-sm resize-y", placeholder: r[lang], value: texts[lang]?.[r.path] || "",
                    onChange: (e) => set(lang, r.path, e.target.value), "data-testid": `text-${lang}-${r.path}`,
                  };
                  return (
                    <label key={lang} className="block">
                      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[var(--muted)]">{lang === "en" ? "English" : "Português"}</span>
                      {long ? <textarea rows={3} {...props} /> : <input {...props} />}
                    </label>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
